import React from 'react';
import { func, instanceOf } from 'prop-types';
import some from 'lodash/some';
import DECheckbox from '../../../shared/DECheckbox';
import { _getCheckedDefination } from '../../../../../util/deUtils';

const DefinitionTableHeader = ({ data, setSelectedDefinition }) => {
  const activeDefExp = _getCheckedDefination(data.data, 'isActive');
  const isDisabled = !some(data.data, item => item.isDisabled === false);
  let isIndeterminate = false;
  let isChecked = false;
  if (activeDefExp.length > 0) {
    isIndeterminate = true;
    isChecked = true;
    if (activeDefExp.length === data.data.length) {
      isIndeterminate = false;
    }
  }
  const _handleSelectAll = checkSate => {
    setSelectedDefinition(checkSate, null, data.id, true);
  };

  return (
    <div className="de--def--table__head datahub-table--head">
      <div className="de--def--table__row">
        <div className="de--def--table__col de--def--col__select">
          <DECheckbox
            onChange={_handleSelectAll}
            id="ct_select_all"
            isChecked={isChecked}
            data={{ all: true }}
            disabled={isDisabled}
            indeterminate={isIndeterminate}
          />
        </div>

        <div className="de--def--table__col de--def--col__name">
          Definitions
        </div>

        <div className="de--def--table__col de--def--col__sample">Sample</div>

        <div className="de--def--table__col de--def--col__wgth">
          Weighted(000)
        </div>
      </div>
    </div>
  );
};

DefinitionTableHeader.propTypes = {
  setSelectedDefinition: func,
  data: instanceOf(Object),
};

export default DefinitionTableHeader;
